import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {getDisplayName} from '../../utils';

const withClickOutside = (WrappedComponent) => {
  class WithClickOutside extends Component {
    static propTypes = {
      onClickOutside: PropTypes.func,
    };

    static defaultProps = {
      onClickOutside: () => {},
    };

    constructor(props) {
      super(props);

      this.containerRef = React.createRef();
    }

    state = {
      clickOutside: false,
    };

    componentDidMount() {
      document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside);
    }

    handleClickOutside = (e) => {
      const {onClickOutside} = this.props;

      if (!this.containerRef.current.contains(e.target)) {
        return this.setState({clickOutside: true}, onClickOutside);
      }

      return this.setState({clickOutside: false});
    };

    render() {
      const {clickOutside} = this.state;

      return (
        <div ref={this.containerRef}>
          <WrappedComponent clickOutside={clickOutside} {...this.props}/>
        </div>
      );
    }
  }

  WithClickOutside.displayName = `WithClickOutside(${getDisplayName(WrappedComponent)})`;

  return WithClickOutside;
};

export default withClickOutside;
